import { call, put, takeEvery, all, fork } from "redux-saga/effects";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import {
  GET_TRANSFER,
  DELETE_TRANSFER,
  UPDATE_TRANSFER,
  ADD_NEW_TRANSFER,
} from "./actionType";

import {
  getTransferSuccess,
  getTransferFail,
  deleteTransferSuccess,
  deleteTransferFail,
  updateTransferSuccess,
  updateTransferFail,
  addTransferSuccess,
  addTransferFail,
} from "./action";

//Include Both Helper File with needed carriers
import {
  approveTransferApi,
  getTransferApi,
  updateTransferApi,
  deleteTransferApi,
  addNewTransferApi
} from "../../helpers/backend_helper";

function* getTransfer({ payload: transfer }) {
  try {
    const response = yield call(getTransferApi, transfer);
    yield put(getTransferSuccess(GET_TRANSFER, response.data));
  } catch (error) {
    yield put(getTransferFail(GET_TRANSFER, error));
  }
}

function* onUpdateTransfer({ payload: transfer }) {
  try {
    if (transfer.setApprove) {
      const response = yield call(approveTransferApi, transfer);
      yield put(updateTransferSuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    }
    else {
      const response = yield call(updateTransferApi, transfer);
      yield put(updateTransferSuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    }
  } catch (error) {
    yield put(updateTransferFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onDeleteTransfer({ payload: transfer }) {
  try {
    const response = yield call(deleteTransferApi, transfer);
    yield put(deleteTransferSuccess({ transfer, ...response }));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(deleteTransferFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onAddNewTransfer({ payload: transfer }) {
  try {
    const response = yield call(addNewTransferApi, transfer);
    yield put(addTransferSuccess(response));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(addTransferFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }

}

export function* watchGetTransfer() {
  yield takeEvery(GET_TRANSFER, getTransfer);
}

export function* watchUpdateTransfer() {
  yield takeEvery(UPDATE_TRANSFER, onUpdateTransfer);
}

export function* watchDeleteTransfer() {
  yield takeEvery(DELETE_TRANSFER, onDeleteTransfer);
}

export function* watchAddNewTransfer() {
  yield takeEvery(ADD_NEW_TRANSFER, onAddNewTransfer);
}

function* transferSaga() {
  yield all([
    fork(watchGetTransfer),
    fork(watchDeleteTransfer),
    fork(watchUpdateTransfer),
    fork(watchAddNewTransfer)
  ]);
}

export default transferSaga;
